if (!customElements.get('landing-social-proof')) {
  customElements.define(
    'landing-social-proof',
    class LandingSocialProof extends HTMLElement {
      connectedCallback() {
        this.initFilters();
      }

      initFilters() {
        const filterBar = this.querySelector('[data-filter-bar]');
        const reviewGrid = this.querySelector('[data-reviews-grid]');
        if (!filterBar || !reviewGrid) return;

        const firstBtn = filterBar.querySelector('[data-filter]');
        if (firstBtn) this.applyFilter(filterBar, reviewGrid, firstBtn.dataset.filter);

        filterBar.addEventListener('click', (e) => {
          const btn = e.target.closest('[data-filter]');
          if (!btn) return;
          this.applyFilter(filterBar, reviewGrid, btn.dataset.filter);
        });
      }

      applyFilter(filterBar, reviewGrid, filter) {
        filterBar.querySelectorAll('[data-filter]').forEach(b => {
          b.classList.toggle('bg-primaryDark', b.dataset.filter === filter);
          b.classList.toggle('text-primaryLight', b.dataset.filter === filter);
          b.classList.toggle('bg-transparent', b.dataset.filter !== filter);
          b.classList.toggle('text-primaryDark', b.dataset.filter !== filter);
        });

        reviewGrid.querySelectorAll('[data-review-card]').forEach(card => {
          card.style.display = card.dataset.condition === filter ? '' : 'none';
        });
      }
    }
  );
}
